
        var result = require("!!../../../../node_modules/css-loader/index.js!./history.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/history/history.component.css
// module id = 565
// module chunks = 0